"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const chromatism_1 = require("chromatism");
const ripple = (0, styled_components_1.keyframes) `
    from {
        left: -200%;
    }
    to {
        left: 200%;
    }
`;
const Placeholder = styled_components_1.default.span `
  background-color: ${({ theme }) => theme.neutral.light};
  display: block;
  border-radius: ${({ circle }) => (circle ? "50%" : "8px")};
  position: relative;
  overflow: hidden;
  width: ${({ size, circle }) => (circle ? `${size}px` : "100%")};
  ${({ maxWidth }) => maxWidth &&
    (0, styled_components_1.css) `
      max-width: ${maxWidth};
    `};
  height: ${({ size }) => `${size}px`};
  &::before {
    content: "";
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 150%;
    height: 100%;
    animation: ${ripple} 1600ms linear infinite;
    background: ${({ theme }) => `linear-gradient(to right, ${theme.neutral.light}, ${(0, chromatism_1.brightness)(-5, theme.neutral.light).hex}, ${theme.neutral.light})`};
  }
`;
const RotaPlaceholder = (_a) => {
    var { size = 40, circle = false, maxWidth } = _a, props = __rest(_a, ["size", "circle", "maxWidth"]);
    return (react_1.default.createElement(Placeholder, Object.assign({ size: size, circle: circle, maxWidth: maxWidth }, props)));
};
exports.default = RotaPlaceholder;
